/**
 * Check if we should show the currency conversion link,
 * which allows the user to select a currency conversion option
 * @param {Object} selectedFundingOption - the selected funding option
 * @return {Boolean} showCurrencyConversionLink - if we should show the conversion link
 */
export function shouldShowCurrencyConversionLink(selectedFundingOption = {}) {
  let { funding_sources = [] } = selectedFundingOption

  // we pull the last funding source off the array which will be the credit card
  const fundingSourceToCheck = funding_sources[funding_sources.length - 1]
  if (fundingSourceToCheck) {
    return !fundingSourceToCheck.disableCurrencyConversion
  }
  return false
}
